import { StyleSheet } from 'aphrodite';

export default StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#F6F8F9',
  },

  disable: {
    opacity: 0.5,
    cursor: 'not-allowed',
  },

  marginTop0: {
    marginTop: 0,
  },

  top: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: '0 188px',
    paddingTop: 20,
    margin: '0 auto',
    width: '100%',
    height: 68,
  },

  btns: {
    flexDirection: 'row',
    fontSize: 12,
    height: 28,
    lineHeight: '24px',
    color: '#878F98',
    border: '1px solid #878F98',
    borderRadius: '3px',
  },

  btn: {
    width: 80,
    textAlign: 'center',
    cursor: 'pointer',
  },

  selectedBtn: {
    backgroundColor: '#32363A',
    color: '#FFFFFF',
  },

  btns2: {
    flexDirection: 'row',
  },

  lBox: {
    flex: 1,
    flexDirection: 'row',
    marginTop: 14,
  },

  strip: {
    position: 'relative',
    marginTop: 2,
    marginLeft: 10,
    width: 28,
    height: 14,
    borderRadius: '40px',
    backgroundColor: '#c3ccd1',
    cursor: 'pointer',
  },

  stripActive: {
    backgroundColor: '#385DAE',
  },

  round: {
    position: 'absolute',
    top: 1,
    left: 1,
    width: 12,
    height: 12,
    borderRadius: '50%',
    backgroundColor: '#ffffff',
  },

  roundActive: {
    left: 'none',
    right: 1,
  },

  listeningBtn: {
    marginLeft: 20,
    fontSize: 12,
    color: '#32363a',
  },

  contentBox: {
    position: 'relative',
    flex: 1,
    padding: '0 188px',
    overflow: 'hidden',
  },

  content: {
    margin: '0 auto',
    padding: 40,
    paddingBottom: 25,
    minWidth: '600px',
    width: '100%',
    height: '100%',
    backgroundColor: '#fff',
    overflowY: 'auto',
  },

  sentenceContent: {
    backgroundImage: `url(${require('./assets/sentence.png')})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100%',
    backgroundPosition: 'bottom',
  },

  sentenceTop: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },

  sentenceBtns: {
    flexDirection: 'row',
  },

  sentenceBtn: {
    marginLeft: 10,
    width: 80,
    height: 28,
    color: '#32363A',
    backgroundColor: '#fff',
    borderRadius: '3px',
    border: '1px solid #878F98',
    ':hover': {
      backgroundColor: '#fff',
    },
  },

  sentenceParagraph: {
    marginTop: 56,
    marginBottom: 40,
    color: '#32363A',
    cursor: 'initial',
  },

  welcomeContent: {
    justifyContent: 'center',
    alignItems: 'center',
    padding: 0,
    backgroundImage: `url(${require('./assets/welcome.png')})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100%',
    backgroundPosition: 'bottom',
  },

  welcomeBg: {
    width: 240,
    height: 240,
    backgroundImage: `url(${require('./assets/bg.png')})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },

  welcomeIcon: {
    width: 80,
    height: 80,
  },

  welcomeH1: {
    marginTop: -60,
    fontSize: 24,
    fontWeight: 'bold',
    textAlign: 'center',
  },

  welcomeP: {
    flexDirection: 'row',
    justifyContent: 'center',
    marginTop: 20,
    fontSize: 14,
    color: '#878F98',
  },

  welcomeP2: {
    marginLeft: 4,
    marginRight: 4,
    color: '#32363A',
  },

  welcomeImage: {
    marginTop: 148,
    width: '100%',
    height: 127,
    backgroundImage: `url(${require('./assets/welcome.png')})`,
    backgroundSize: 'cover',
  },

  tipBox: {
    position: 'absolute',
    bottom: 0,
    left: 20,
    padding: 20,
    width: 148,
    fontSize: 12,
    backgroundColor: '#fff',
    textAlign: 'center',
  },

  tipLine: {
    marginTop: 10,
    marginBottom: 10,
    width: '100%',
    height: 1,
    backgroundColor: '#C3CCD1',
  },

  tipItem: {
    flexDirection: 'row',
    marginTop: 10,
  },

  tipItemKey: {
    marginRight: 4,
    width: 26,
    height: 16,
    borderRadius: '2px',
  },

  paragraph: {
    position: 'relative',
    marginTop: 40,
    color: '#878F98',
    cursor: 'pointer',
    ':first-child': {
      marginTop: 0,
    },
  },

  sentenceHide: {
    color: '#EEF1F3',
    backgroundColor: '#EEF1F3',
    userSelect: 'none',
  },

  sentenceHideSelected: {
    color: '#C3CCD1',
    backgroundColor: '#C3CCD1',
  },

  sentence: {
    width: 'fit-content',
    lineHeight: '24px',
    ':last-child': {
      marginTop: 12,
    },
  },

  selectedIcon: {
    position: 'absolute',
    left: -24,
    top: 2,
    width: 16,
    height: 16,
  },

  selectedIconPlay: {
    left: -22,
    top: 4,
    width: 12,
    height: 12,
  },

  bottom: {
    marginTop: 40,
  },

  bottomButton: {
    margin: '0 auto',
    width: 120,
    height: 40,
    lineHeight: '40px',
    fontSize: 14,
    color: '#fff',
    backgroundColor: '#385DAE',
    ':hover': {
      backgroundColor: '#385DAE',
    },
  },

  isListen: {
    backgroundColor: '#fff',
    borderRadius: '3px',
    border: '1px solid #878F98',
    color: '#32363A',
    ':hover': {
      backgroundColor: '#fff',
    },
  },

  bottomText: {
    marginTop: 20,
    fontSize: 12,
    color: '#878F98',
    textAlign: 'center',
  },

  audio: {
    marginTop: 20,
    width: '100%',
    height: 64,
    background: '#FFFFFF',
    boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.1)',
  },

  audioContent: {
    margin: '0 auto',
    width: 1064,
  },

  color385DAE: {
    color: '#385DAE',
  },

  noTranslation: {
    opacity: 0.5,
  },
  hasNoTranslation: {
    display: 'none',
  },
});



// WEBPACK FOOTER //
// ./src/components/listen/content/styles.js